// extracted by mini-css-extract-plugin
module.exports = {"errorpage":"ErrorPage_errorpage__aXngD","inner":"ErrorPage_inner__hDdUt","title":"ErrorPage_title___VF1c","navigation":"ErrorPage_navigation__ZOLvK","link":"ErrorPage_link__h7qMN"};